/* jQuery */
window.$ = window.jQuery = require('jquery');

import axios from 'axios';
import Inputmask from 'inputmask';
import {debounce, throttle} from './utils/debounce';
import {scrollTo} from './utils/scroll';
import './utils/polyfill';

/**
 * @type {Map<string, Element>}
 */
const elements = new Map();

/**
 * @param {string} name
 * @param {?string} selector
 *
 * @return {Map}
 */
elements.store = function (name, selector = undefined) {
  const el = document.querySelector(selector || name);
  if (el) {
    this.set(name, el);
  }
  return this;
};

// Collecting elements
elements.store('header');
elements.store('mobile.menu.btn', '.mobile-menu-trigger');
elements.store('leap.up', '.n-leap--up');
elements.store('form.donate', '#donate-form');
elements.store('form.subscribe', '#subscribe-form');

/**
 * @param {Element} el
 *
 * @returns {boolean}
 */
function isVisible(el) {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}

// Scrolling

/**
 *
 * @param {number} y
 * @param {number} vh
 */
const handleLeapUp = (y, vh) => {
  const el = elements.get('leap.up');

  if (el && isVisible(el)) {
    el.dataset.state = y > vh ? 'in' : 'out';
  }
};

const handleScroll = throttle(function onWindowScroll() {
  const y = window.scrollY;
  const vh = window.innerHeight;

  handleLeapUp(y, vh);
}, 200);

window.addEventListener('scroll', handleScroll);

document
  .querySelectorAll('[data-scroll]')
  .forEach(el => el.addEventListener('click', scrollTo));

// Menu

const toggleMobileMenu = (isOpen) => {
  document.body.classList.toggle('block-scroll', isOpen);
  elements.get('header').classList.toggle('open', isOpen);
  elements.get('mobile.menu.btn').classList.toggle('open', isOpen);
};

const handleNavLink = () => {
  toggleMobileMenu(false);
};

if (elements.has('mobile.menu.btn')) {
  elements
    .get('mobile.menu.btn')
    .addEventListener('click', function onHandleMobileMenu(event) {
      event.preventDefault();
      toggleMobileMenu(!event.currentTarget.classList.contains('open'));
    });
}

document
  .querySelectorAll('.mobile-nav .nav-link')
  .forEach(el => el.addEventListener('click', handleNavLink));

// Donate Form
{
  if (elements.has('form.donate')) {
    const form = elements.get('form.donate');
    const amountInput = form.querySelector('#amount');
    const dedicatedInput = form.querySelector('#dedicated');
    const treesInput = form.querySelector('#trees');
    const typeInput = form.querySelector('#type');
    const treePrice = parseFloat(amountInput.dataset.price) || 0;

    const inputValue = (value, type = 'int') => {
      let newValue = value.replace(/^\D+/g, '');

      if (type === 'float') {
        newValue = parseFloat(newValue.replace(',', '.'));
      } else {
        newValue = parseInt(value, 10);
      }

      return (!isFinite(newValue) || newValue < 0) ? 0 : newValue;
    };

    Inputmask('$999{*}', {
      placeholder: '',
      removeMaskOnSubmit: true,
    }).mask(amountInput);

    const totalAmount = (count) => count * treePrice;
    const totalTrees = (amount) => Math.floor(amount / treePrice);

    amountInput.addEventListener('input', debounce(function onAmountInput(event) {
      treesInput.value = totalTrees(inputValue(event.target.value, 'float'));
    }, 50));

    treesInput.addEventListener('input', debounce(function onTreeInput(event) {
      amountInput.value = `${totalAmount(inputValue(event.target.value))}`;
    }, 50));

    const dedicatedSections = form.querySelectorAll('[data-dedicated="true"]');

    dedicatedInput.addEventListener('change', (event) => {
      const isChecked = event.target.checked;

      dedicatedSections
        .forEach(el => el.classList.toggle('d-flex', isChecked));
    });

    const typeSections = form.querySelectorAll('[data-type]');

    typeInput.addEventListener('change', (event) => {
      const type = event.target.checked ? 'corporate' : 'personal';

      typeSections
        .forEach(el => el.classList.toggle('d-none', el.dataset.type !== type));

      if (type === 'corporate') {
        const changeEvent = new Event('change');

        dedicatedInput.checked = false;
        dedicatedInput.dispatchEvent(changeEvent);
      }
    });

    const submitButton = form.querySelector('[type="submit"]');

    form
      .querySelector('#terms')
      .addEventListener('change', function onTermsChange(event) {
        submitButton.disabled = !event.target.checked;
      });
  }
}

// Subscribe
{
  const timeout = ms => new Promise(res => setTimeout(res, ms));

  const submitSubscribeForm = async () => {
    event.preventDefault();

    const form = event.target;
    const inputBox = form.querySelector('.input-box');
    const feedback = form.querySelector('.invalid-feedback');

    form.classList.add('is-loading');
    await timeout(1000);

    try {
      await axios.post(form.getAttribute('action'), {
        email: form.elements.email.value,
      });

      form.classList.add('is-complete');
    } catch (error) {
      const data = error.response.data;

      feedback.textContent = data.errors && data.errors.email || data.description || 'Something went wrong.';
      inputBox.classList.add('is-invalid');
    }

    form.classList.remove('is-loading');
  };

  if (elements.has('form.subscribe')) {
    elements
      .get('form.subscribe')
      .addEventListener('submit', submitSubscribeForm);
  }
}

{
  const handleItem = function toggleAccordionItem(event) {
    event.preventDefault();

    const target = event.currentTarget;
    const body = target.nextElementSibling;

    target.classList.toggle('active');
    body.style.maxHeight = body.style.maxHeight ? null : `${body.scrollHeight}px`;
  };

  document
    .querySelectorAll('.accordion')
    .forEach(el => el.addEventListener('click', handleItem));
}

// Run
(function main() {
  handleScroll();
})();



// WEBPACK FOOTER //
// ./resources/js/app.js